


<script>
import { Bar } from 'vue-chartjs'

export default {
  extends: Bar,
  data: () => ({
    chartdata: {
      labels: ['Mon', 'Tues', 'Wed', 'Thurs', 'Fri'],
      datasets: [
        {
          label: 'Time spent',
          backgroundColor: '#c3375b',
          data: [40, 10, 20, 0, 10, 10]
        }
      ]
    },
    options: {
      responsive: true,
      maintainAspectRatio: false
    }
  }),
  mounted() {
    this.renderChart(this.chartdata, this.options)
  },
  methods: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Chart.vue